import React from 'react'
import Styled from 'styled-components'

interface Props {
  title: React.ReactNode;
  content: React.ReactNode;
}

export default function CompliancePages({ title, content }: Props) {
  return (
    <StyledContainer className="terms">
      <h1 className="terms__title">{title}</h1>
      <div>{content}</div>
    </StyledContainer>
  )
}

const StyledContainer = Styled.div`
  width: 860px;
  box-sizing: border-box;
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  border-top: none;
  border: 2px solid #e2e2e2;
  @media (max-width: 640px) {
    width: 100%;
    border-radius: 0;
    margin: 0;
    border: 0;
  }

  &.terms {
    font-size: 14px;
    line-height: 1.5;
    padding: 24px 32px;
    background: #fff;
    margin: 20px auto;
    @media (max-width: 640px) {
      padding: 0;
    }
    ol {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    .terms__title {
      text-align: center;
      font-size: 24px;
      margin-bottom: 24px;
    }

    .terms__text {
        margin-top: 40px;
    }

    .terms-list {
        margin-top: 50px;
    }

    .p-terms__section+.p-terms__section {
        margin-top: 40px;
    }

    .p-terms__sectionTitle {
        font-size: 16px;
        margin-bottom: 10px;
    }

    .p-terms__body {
        counter-reset: p-terms-section-count;
    }

    .p-terms__section {
        position: relative;
        padding-left: 24px;
    }

    .p-terms__section:before {
        font-size: 16px;
        position: absolute;
        left: -8px;
        min-width: 28px;
        font-weight: 700;
        text-align: right;
        content: counter(p-terms-section-count) ".";
        counter-increment: p-terms-section-count;
    }

    .p-terms__sectionBody {
        counter-reset: subsection-count;
    }

    .p-terms__subsection {
        position: relative;
        padding-left: 24px;
    }

    .p-terms__subsection:before {
        position: absolute;
        left: -10px;
        min-width: 28px;
        text-align: right;
        content: "(" counter(subsection-count) ")";
        counter-increment: subsection-count;
    }

    .p-terms__subsection.-lst {
        padding-left: 0;
    }

    .p-terms__subsection.-lst:before {
        display: none;
    }

    .p-terms__subsection+.p-terms__subsection {
        margin-top: 10px;
    }

    .p-terms__subsection h4 {
        font-weight: 400;
        margin-bottom: 5px;
    }

    .p-terms__subsection p {
        margin: 0;
    }

    .p-terms__subsection ol {
        margin-top: 8px;
    }

    .p-terms__subsection ol li {
        position: relative;
        word-break: break-all;
    }

    .p-terms {
        &.-listNumNone {
            .p-terms__body {
                counter-reset: none;
            }

            .p-terms__section:before {
                content: "";
                counter-increment: none;
            }

            .p-terms__subsection:before {
                content: "";
                counter-increment: none;
            }

            .p-terms__subsection ol li:before {
                content: "";
                counter-increment: none;
            }
        }
    }

    .table,
    td,
    th {
        border: 1px solid #595959;
        border-collapse: collapse;
        padding: 8px 16px;
        text-align: left;
    }

    tr,
    td {
        width: 50%;
    }

    .has-text-center {
        text-align: center;
    }

    .has-text-right {
        text-align: right;
    }

    .ql-align-right {
        text-align: right;
    }

    .ql-align-center {
        text-align: center;
    }

    .ql-indent-1 {
        position: relative;
        padding-left: 20px;
    }

    .ql-indent-2 {
        position: relative;
        padding-left: 40px;
    }

    .ql-indent-3 {
        position: relative;
        padding-left: 60px;
    }

    .ql-indent-1 {
        position: relative;
        padding-left: 20px;
    }

    .ql-indent-2 {
        position: relative;
        padding-left: 40px;
    }

    .ql-indent-3 {
        position: relative;
        padding-left: 60px;
    }
  }
`

